/**
 * Frontend convention: an absent proposal is `undefined`, never `null` or `''`.
 *
 * The backend serializes a missing proposal as JSON/`null` (C# `null`). React Query keys and
 * strict `===` treat those as different from `undefined`, so live-route caches silently fail
 * to match. Call this in each event handler that reads `ProposalId`.
 */
export function normalizeProposalId(proposalId?: string | null): string | undefined {
  return proposalId ? proposalId : undefined;
}
